/** Palomita de las casillas marcadas. */
export function CheckIcon() {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true">
      <path d="M6.2 12.4 2 8.2l1.5-1.5 2.7 2.7L12.5 3l1.5 1.5z" />
    </svg>
  )
}
